import { ExternalAccountingProviderType } from 'shared/types/Invoicing';

import apiClient from '@/services/networking/apiClient';
import {
    AccountingLog,
    AuthorizeAccountingProviderResponsePayload,
    GetAccountingLogsResponsePayload,
    GetAccountingProviderSalesCodesResponsePayload,
    GetAccountingUserStatusResponsePayload,
    RefreshConnectionResponsePayload,
} from '@/types/invoicing';

async function authorize(
    provider: ExternalAccountingProviderType,
): Promise<AuthorizeAccountingProviderResponsePayload> {
    const { data } =
        await apiClient.v1.post<AuthorizeAccountingProviderResponsePayload>(
            '/accounting/authorize',
            {
                app: 'web',
                provider,
            },
        );

    return data;
}

async function getAccountingUserStatus(): Promise<GetAccountingUserStatusResponsePayload> {
    const { data } =
        await apiClient.v1.get<GetAccountingUserStatusResponsePayload>(
            '/accounting/user_status',
        );

    return data;
}

async function refreshConnection(): Promise<RefreshConnectionResponsePayload> {
    const { data } = await apiClient.v1.get<RefreshConnectionResponsePayload>(
        '/accounting/refresh_connection',
    );

    return data;
}

async function getProviderSalesCodes(
    provider: ExternalAccountingProviderType,
): Promise<GetAccountingProviderSalesCodesResponsePayload> {
    const { data } =
        await apiClient.v1.get<GetAccountingProviderSalesCodesResponsePayload>(
            '/accounting/account_codes',
            {
                params: {
                    provider,
                },
            },
        );

    return data;
}

async function triggerContactsImportFromXero(): Promise<void> {
    await apiClient.v1.post('/accounting/import_contacts');
}

async function triggerInvoicesSyncToXero(): Promise<void> {
    await apiClient.v1.post('/accounting/sync_invoices');
}

async function getAccountingLogs(): Promise<AccountingLog[]> {
    const { data } = await apiClient.v1.get<GetAccountingLogsResponsePayload>(
        '/accounting/logs',
    );

    return data.payload;
}

export const AccountingProvidersAPI = {
    authorize,
    getAccountingUserStatus,
    getProviderSalesCodes,
    refreshConnection,
    triggerContactsImportFromXero,
    triggerInvoicesSyncToXero,
    getAccountingLogs,
};
